import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './utils/auth/authConfig';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { OfflineSwitchProvider } from "utils/helper/OfflineSwitchContext";
import { getSwitchStateFromDB } from 'utils/services/idbService';
import AppOwnsDataWebApi from './services/AppOwnsDataWebApi';

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const msalInstance = new PublicClientApplication(msalConfig);
let userLoginProcessed = false;
// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback(async (event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    if(event.payload.accessToken){
      // const {account: loginAccount, ...rest} = event.payload
      // const account = {...loginAccount, ...rest}
      msalInstance.setActiveAccount(event.payload.account);
      if (!userLoginProcessed) {
          userLoginProcessed = true;
          //await AppOwnsDataWebApi.LoginUser();
      }
    }
  }
});

export const globalLogout = async () => {
  const isOnline = navigator.onLine;
  const storedToken = localStorage.getItem('auth_token');

  const username = localStorage.getItem('currentUser') || 'unknown';
  const newState = await getSwitchStateFromDB("user_switch_state", username);
  const shouldLogOut = isOnline && (newState !== undefined ? newState : true);

  if (shouldLogOut && storedToken) {
    msalInstance.logoutRedirect({
      postLogoutRedirectUri: "/"
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <OfflineSwitchProvider>
      <BrowserRouter>
        <App instance={msalInstance} />
      </BrowserRouter>
    </OfflineSwitchProvider>
  </React.StrictMode>
);
serviceWorkerRegistration.register();
